export const getAuthApiOrigin = () => {
  const configuredOrigin =
    process.env.REACT_APP_AUTH_API_BASE_URL ||
    process.env.REACT_APP_API_BASE_URL ||
    "https://auth-api.manabakh.ir/v1/auth/api";
  return configuredOrigin.replace(/\/+$/, "");
};

export const getAuthApiRoute = (url) =>
  `${getAuthApiOrigin()}/${String(url || "").replace(/^\/+/, "")}`;

export const getAuthMediaOrigin = () => {
  const configuredOrigin =
    process.env.REACT_APP_MEDIA_BASE_URL ||
    `${getAuthApiOrigin()}/user-media`;
  return configuredOrigin.replace(/\/+$/, "");
};

export const getAuthMediaRoute = (filename) =>
  `${getAuthMediaOrigin()}/${String(filename || "").replace(/^\/+/, "")}`;

export const resolveAuthMediaUrl = (value) => {
  if (!value) return "";
  var source = String(value);
  if (/^(?:https?:|data:|blob:)/i.test(source)) return source;
  return getAuthMediaRoute(source);
};

export const getCMSApiOrigin = () =>
  (
    process.env.REACT_APP_CMS_API_BASE_URL ||
    "https://cms-api.manabakh.ir/v1/cms/api"
  ).replace(/\/+$/, "");

export const getCMSApiRoute = (url) =>
  `${getCMSApiOrigin()}/${String(url || "").replace(/^\/+/, "")}`;

export const getBillingApiOrigin = () =>
  (
    process.env.REACT_APP_BILLING_API_BASE_URL ||
    "https://billing-api.manabakh.ir/v1/billing/api"
  ).replace(/\/+$/, "");

export const getBillingApiRoute = (url) =>
  `${getBillingApiOrigin()}/${String(url || "").replace(/^\/+/, "")}`;

export const getCMSImageURL = (imageName) =>
  `https://fcdn.manabakh.ir/images/${imageName}`;

export const getArtistImageURL = (imageName) =>
  `https://fcdn.manabakh.ir/images/${imageName}`;

export const getAdvertisementApiOrigin = () => {
  const configuredOrigin =
    process.env.REACT_APP_ADVERTISEMENT_API_URL ||
    "https://advertisement-api.manabakh.ir";
  return configuredOrigin.replace(/\/+$/, "");
};

export const getAdvertisementApiRoute = (url) =>
  `${getAdvertisementApiOrigin()}/v1/advertisement/api/${url}`;
